<template>
  <v-chip x-small :color="color" dark>{{ status }}</v-chip>
</template>

<script>
/**
 * Estado de un contrato, con su color.
 *
 * Los estados estaban repetidos en cuatro lugares del mantenedor, y el color
 * por defecto era gris: un estado desconocido se pintaba igual que un churn,
 * sin que nadie lo notara. Acá un valor fuera de la lista se ve distinto, que
 * es lo que uno quiere de algo inesperado.
 */
export const CONTRACT_STATUSES = ['Activo', 'Pausado', 'Churned'];

const STATUS_COLORS = {
  Activo: 'success',
  Pausado: 'warning',
  Churned: 'secondary'
};

export default {
  name: 'ContractStatusChip',
  props: {
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    color() {
      return STATUS_COLORS[this.status] || 'error';
    }
  }
};
</script>
